import { render, staticRenderFns } from "./CopySection.vue?vue&type=template&id=3963315a&"
import script from "./CopySection.vue?vue&type=script&lang=js&"
export * from "./CopySection.vue?vue&type=script&lang=js&"
import style0 from "./CopySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports